export default __webpack_public_path__ + "static/media/ic-linkedin-dark.2d643585.svg";